export default "__VITE_ASSET__C71w6QKA__"